import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-search-inp',
  standalone: true,
  imports: [TranslateModule, FormsModule, CommonModule],
  templateUrl: './search-inp.component.html',
  styleUrl: './search-inp.component.scss',
  // encapsulation: ViewEncapsulation.None
})
export class SearchInpComponent {
  @Output() search = new EventEmitter<string>()
  value: string = ''
  onSearch() {
    this.search.emit(this.value);
  }
}
